import React, { Component } from 'react';
import { connect } from 'react-redux';
import HdpContentWrapper from 'app/shared/modules/hdp/HdpContentWrapper';
import Text from 'app/shared/core/Text';
import { StyledHdpLegalInfo, StyledHdpLegalInfoTextWrapper } from './styles';

type HdpLegalInfoProps = {
  listing: {
    legalDisclaimer: string;
  };
};

class HdpLegalInfo extends Component<HdpLegalInfoProps> {
  render() {
    const { listing } = this.props;
    return (
      <StyledHdpLegalInfo>
        <HdpContentWrapper collapsable header="Legal info" headerHtmlTag="h2">
          <Text size="md">
            <StyledHdpLegalInfoTextWrapper
              dangerouslySetInnerHTML={{
                __html: listing.legalDisclaimer,
              }}
            />
          </Text>
        </HdpContentWrapper>
      </StyledHdpLegalInfo>
    );
  }
}

export default connect()(HdpLegalInfo);
